<template>
  <table class="ks-is-fullwidth">
    <template v-if="details.DiscValue !== null || details.DiscPercent !== null">
      <tr>
        <td>
          {{ Catalog.TotalBruto.Label }}
        </td>
        <td class="has-text-right">
         <kst-value class="print-thermal-size" field="TotalBruto" :data="details" :catalog="Catalog"/>
        </td>
      </tr>

      <tr>
        <td class="is-flex">
          <template v-if="details.DiscValue !== null">
            {{ Catalog.DiscValue.PrintLabel }}
          </template>
          <template v-else-if="details.DiscPercent !== null">
            {{ Catalog.DiscPercent.PrintLabel }}
            (<kst-value class="print-thermal-size" field="DiscPercent" :data="details" :catalog="Catalog"/>)
          </template>
        </td>
        <td class="has-text-right">
          <kst-value class="print-thermal-size" field="TotalDisc" :data="details" :catalog="Catalog"/>
        </td>
      </tr>
    </template>

    <tr>
      <td>
        {{ Catalog.Total.Label }}
      </td>
      <td class="has-text-right">
        <kst-value class="print-thermal-size" field="Total" :data="details" :catalog="Catalog"/>
      </td>
    </tr>

    <tr>
      <td>
        {{ Catalog.TotalItems.Label }}
      </td>
      <td class="is-flex is-justify-content-end">
        <kst-value class="ks-space-right print-thermal-size"
          field="TotalItems" :data="details" :catalog="Catalog"
        />
        {{ Catalog.TotalItems.HelpLabel }}
      </td>
    </tr>

    <template v-if="details.PaymentTypeName !== null">
      <tr>
        <td>
          {{ details.PaymentTypeName }}
        </td>
        <td class="has-text-right">
          <kst-value class="print-thermal-size" field="PaymentValue" :data="details" :catalog="Catalog"/>
        </td>
      </tr>

      <tr>
        <td>
          {{ Catalog.PaymentReturn.Label }}
        </td>
        <td class="has-text-right">
          <kst-value class="print-thermal-size" field="PaymentReturn" :data="details" :catalog="Catalog"/>
        </td>
      </tr>
    </template>
  </table>
</template>

<script>
import Catalog from "../InvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>